import React from 'react';
import { TextStyle, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';

interface Props {
    value: string;
    title: string;
    maxWidth?: TextStyle['maxWidth'];
    isLink?: boolean;
}

function Label({ title, value, maxWidth, isLink }: Props) {
    const { styles } = useStyles(stylesheet);
    return (
        <View style={styles.container}>
            <MyAppText style={styles.title}>{title}</MyAppText>
            <MyAppText style={styles.value(maxWidth, isLink ?? false)}>{value}</MyAppText>
        </View>
    );
}

const stylesheet = createStyleSheet(() => ({
    container: {
        flexDirection: 'column',
        flexWrap: 'wrap',
        flexShrink: 1
    },

    title: {
        fontSize: 16,
        fontWeight: '700'
    },

    value: (maxWidth: TextStyle['maxWidth'] = 200, isLink: boolean) => ({
        fontSize: 16,
        maxWidth,
        textDecorationLine: isLink ? 'underline' : undefined,
    })
}));

export default Label;
